/**
 * Video Background Effects Constants
 *
 * Centralized constants for video background blur and replacement features.
 * These values are used across components, actions, and processors.
 *
 * Environment Variables:
 * - VIDEO_FRAME_RATE: Set target frame rate for video processing (10-60 FPS)
 *   Example: VIDEO_FRAME_RATE=30 npm start
 *   Default: 17 FPS if not set
 */

// Background effect modes
export const EFFECT_MODE = {
    NONE: 'none',
    BLUR: 'blur',
    IMAGE: 'image',
};

// Blur amount presets (in pixels)
export const BLUR_AMOUNT = {
    MIN: 5,
    MAX: 100,
    SUBTLE: 25,
    MEDIUM: 50,
    STRONG: 75,
    DEFAULT: 35, // Used when env var not set
};

// Video resolution configurations
export const VIDEO_RESOLUTION = {
    DEFAULT: {
        width: { min: 352, ideal: 640, max: 1280 },
        height: { min: 198, ideal: 360, max: 720 },
    },
    HD: {
        width: { min: 640, ideal: 1280, max: 1920 },
        height: { min: 360, ideal: 720, max: 1080 },
    },
};

// Canvas and stream settings
// Get frame rate from environment variable or use default
const envFrameRate = process.env.VIDEO_FRAME_RATE;
const defaultFrameRate = envFrameRate ? parseInt(envFrameRate, 10) : 17; // Default target FPS for processed stream

export const CANVAS_SETTINGS = {
    FRAME_RATE: Math.max(10, Math.min(60, defaultFrameRate)), // Clamp between 10-60 FPS
    CONTEXT_OPTIONS: {
        willReadFrequently: true,
    },
};

// MediaPipe configuration
export const MEDIAPIPE_CONFIG = {
    MODEL_SELECTION: 1, // 0: general (256x256), 1: landscape (256x144)
    CDN_BASE_URL:
        'https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/',
};
